export class AutomatDevice {
    constructor() {
    }

    _id?:string
}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/models/automatDevice.ts